import axios from 'axios';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '',
});

const buildErrorPayload = (message, kind, status = 0) => ({
  success: false,
  message,
  error_kind: kind,
  status,
});

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('user');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login?expired=true';
      }
      return Promise.resolve({
        data: buildErrorPayload('未登录或登录已过期，请重新登录', 'auth', 401),
      });
    }

    let errorMessage = '未知错误';
    let errorKind = 'server';
    if (error?.response?.status === 429) {
      errorMessage = '请求次数过多，请稍后再试';
      errorKind = 'rate_limit';
    } else if (error?.code === 'ECONNABORTED') {
      errorMessage = '请求超时，请稍后重试';
      errorKind = 'timeout';
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      errorMessage = error.response.data.message;
      errorKind = 'server';
    } else if (error.request) {
      errorMessage = '网络异常，请检查连接后重试';
      errorKind = 'network';
    } else if (error.message) {
      errorMessage = error.message;
      errorKind = 'runtime';
    }
    // Return a fake response so that `const res = await API.get(...)` doesn't get undefined
    // and `res.data` won't crash the frontend.
    return Promise.resolve({
      data: buildErrorPayload(
        errorMessage,
        errorKind,
        error?.response?.status || 0
      ),
    });
  }
);
